import React from 'react';
import { Check, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { AddRequest } from '@/types';
import { useFamilyStore } from '@/store/familyStore';
import { getAncestorLineage } from '@/utils/family/ancestors';

interface RequestListProps {
  requests: AddRequest[];
  isAdmin: boolean;
  onReview: (request: AddRequest) => void;
  onReject: (requestId: string) => void;
}

export function RequestList({ 
  requests = [],
  isAdmin, 
  onReview, 
  onReject 
}: RequestListProps) {
  const { members } = useFamilyStore();

  const getParentLineage = (parentId: string) => {
    const parent = members.find(m => m.id === parentId);
    console.log({members, parent});
    if (!parent) return 'غير محدد';
    return getAncestorLineage(parent.id, members);
  };

  if (!requests?.length) {
    return (
      <p className="p-4 text-center text-gray-500">
        لا توجد طلبات معلقة
      </p>
    );
  }

  return (
    <div className="bg-white shadow-sm rounded-lg divide-y">
      {requests.map((request) => (
        <div
          key={request.id}
          className="p-4 flex items-center justify-between"
        >
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <span className="text-xs bg-primary/10 text-primary px-2 py-1 rounded-full">
                إضافة مولود
              </span>
            </div>
            <div className="text-sm text-gray-600 space-y-1">
              <p>
                <span className="font-medium ml-1">اسم المولود:</span>
                {request.childName}
              </p>
              <p>
                <span className="font-medium ml-1">رقم الهاتف:</span>
                <span className="font-mono" dir="ltr">{request.phoneNumber}</span>
              </p>
              <p>
                <span className="font-medium ml-1">الأب:</span>
                {getParentLineage(request.parentId)}
              </p>
            </div>
            <span
              className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                request.status === 'pending'
                  ? 'bg-yellow-100 text-yellow-800'
                  : request.status === 'approved'
                  ? 'bg-green-100 text-green-800'
                  : 'bg-red-100 text-red-800'
              }`}
            >
              {request.status === 'pending' ? 'قيد المراجعة' : 
               request.status === 'approved' ? 'تمت الموافقة' : 'مرفوض'}
            </span>
          </div>

          {request.status === 'pending' && isAdmin && (
            <div className="flex space-x-2">
              <Button
                variant="ghost"
                size="icon"
                onClick={() => onReview(request)}
                className="text-green-600 hover:text-green-700 hover:bg-green-50 ml-2"
                title="مراجعة الطلب"
              >
                <Check className="h-5 w-5" />
              </Button>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => onReject(request.id)}
                className="text-red-600 hover:text-red-700 hover:bg-red-50"
                title="رفض الطلب"
              >
                <X className="h-5 w-5" />
              </Button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}